module.exports = __webpack_public_path__ + "media/images/icons/rooms/kitchen-ee909266e04c506d1bcb4343411939c2.svg";